// tags button active
$(".tags .button").on('click', function (e) {
    $(".tags .button").removeClass('active');
    $(this).addClass('active');
  });

// article tags
$(".tags.posts .button").on('click', function (e) {

});

// nakoislehdet years
$(".tags.years .button").on('click', function (e) {
    
});
